import Bubbles from './components/Bubbles';

export default Bubbles;



// WEBPACK FOOTER //
// ./src/components/Steps/Bubbles/index.js